/**
 * KpiGroup — inline row of KPI tiles within a Sparc message.
 *
 * Rendered when a `kpi-group` event arrives in the stream. The backend
 * decides per-answer whether to send a structured KPI segment instead of
 * (or alongside) a narrative paragraph. See sketch 002 V1c for the visual
 * intent.
 */

/**
 * @param {object} props
 * @param {object} props.group — { id, kpis: [{ label, value, unit, source }] }
 */
export function KpiGroup({ group }) {
  if (!group || !group.kpis || group.kpis.length === 0) return null

  return (
    <div class="ion-kpi-group" role="group" aria-label="Key metrics">
      {group.kpis.map((kpi, idx) => (
        <KpiCard key={idx} kpi={kpi} />
      ))}
    </div>
  )
}

function KpiCard({ kpi }) {
  const { label, value, unit, source } = kpi
  return (
    <div class="ion-kpi">
      {label && <div class="ion-kpi__label">{label}</div>}
      <div class="ion-kpi__value">
        {value}
        {unit && <span class="ion-kpi__unit">{unit}</span>}
      </div>
      {source && <div class="ion-kpi__source">{source}</div>}
    </div>
  )
}
